import PerformanceTrack from "../../model/performance/PerformanceTrack";
import NumberFormatter from "../../util/NumberFormatter";
import Page from "../framework/Page";
import View from "../framework/View";

export default class PerformanceMetricsRow extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {PerformanceTrack} performanceTrack
     */
    constructor(parentId, elementId, performanceTrack) {
        super(parentId, elementId);

        this.performanceTrack = performanceTrack;

        /**
         * @type {HTMLElement}
         */
        this.countSpan = null;
        /**
         * @type {HTMLElement}
         */
        this.averageSpan = null
        /**
         * @type {HTMLElement}
         */
        this.totalSpan = null;

        /**
         * @type {number}
         */
        this.displayedCount = -1;
        /**
         * @type {number}
         */
        this.displayedAverage = -1;
        /**
         * @type {number}
         */
        this.displayedTotal = -1;
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {
        const parentElement = Page.getElement(this.parentId);

        const container = Page.createElement('div', parentElement, null, 'performance-row');

        
        //////////////////////////////////////////
        // Main Content
        //////////////////////////////////////////
                
        const labelSpan = Page.createElement('span', container, null, null);
        labelSpan.innerHTML = this.performanceTrack.subject;

        this.countSpan = Page.createElement('span', container, null, 'performance-value');
        this.countSpan.innerHTML = '';

        this.averageSpan = Page.createElement('span', container, null, 'performance-value');
        this.averageSpan.innerHTML = '';

        this.totalSpan = Page.createElement('span', container, null, 'performance-value');
        this.totalSpan.innerHTML = '';

        this.setInitialVisibility(true);
        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {

        const count = this.performanceTrack.count;
        const elapsed = this.performanceTrack.elapsed;        

        const average = count > 0 ? (elapsed / count) : 0;

        if (this.displayedCount != count) {
            this.displayedCount = count;
            this.countSpan.innerHTML = NumberFormatter.formatNumber(count);
        }
        
        if (this.displayedAverage != average) {
            this.displayedAverage = average;
            this.averageSpan.innerHTML = NumberFormatter.formatNumber(average);
        }

        if (this.displayedTotal != elapsed) {
            this.displayedTotal != elapsed;
            this.totalSpan.innerHTML = NumberFormatter.formatNumber(elapsed);
        }

        super.updateViewContents();
    }

}